import React, { useEffect, useState } from "react";
import Layout from "../../../components/biblio/Layout";
import Nav from "../../../components/biblio/missions/Nav";
import SubNavAutre from "../../../components/biblio/missions/SubNavAutre";
import { Pencil, Save, Trash } from "../../../components/Icons";
import Modal from "../../../components/Modal";
import { USER_ROLES } from "../../../helpers/Constants";
import { notify } from "../../../helpers/Helper";
import MissionStore from "../../../store/MissionStore";
import UserStore from "../../../store/UserStore";

const Form = ({ annee, reset, close }) => {

   const [current, setCurrent] = useState(annee);

   const handleChange = (e) => {
      setCurrent({ ...current, [e.target.name]: e.target.value })
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      MissionStore.saveAnnee(current).then(_ => {
         notify("Succès", "L'année de mission a été enregistrée.", "success");
         setCurrent(reset);
         e.target.reset();
         close()

      })
   }

   return (
      <form onSubmit={handleSubmit}>

         <div className="mb-3">
            <div className="form-group">
               <span>Année de mission <small className="fw-bold">[obligatoire]</small></span>
               <input type="text" name="libelle" className="form-control" value={current.libelle} onChange={handleChange} required placeholder="Année"/>
            </div>
         </div>
         <button type="submit" style={{ width: '100%' }} className="btn btn-warning mx-auto d-block"><Save /> Enregister</button>
      </form>
   );
}

export default function Annee() {

   const [annees, setAnnees] = useState([]);
   const [annee, setAnnee] = useState({ libelle: "" });
   const [showModal, setShowModal] = useState(false);
   const [loading, setLoaging] = useState(false);

   useEffect(() => {
      if (!UserStore.hasRole(USER_ROLES.ROLE_GESTIONS_MISSION) && !UserStore.hasRole(USER_ROLES.ROLE_RESPONSABLE_ORGANE ) && !UserStore.hasRole(USER_ROLES.ROLE_SUPERVISEUR )) {
         window.location.href = "/bibliotheque";
      }
      init();
   }, [])

   const init = async () => {
      setLoaging(true)
      const { data: _annees } = await MissionStore.getAnnees();
      setAnnees(_annees);
      setLoaging(false)
   }

   const removeAnnee = (id) => {
      if (window.confirm("Supprimer cette année de mission?"))
         MissionStore.removeAnnee(id).then(_ => init())
   }

   const updateAnnee = (annee) => {
      setAnnee(annee);
      setShowModal(true);
   }

   const newAnnee = (e) => {
      e.preventDefault();
      setAnnee({});
      setShowModal(true);
   }

   const onModalClose = () => {
      init();
      setAnnee({ libelle: "" })
      setShowModal(false);
   }

   const Body = () => {
      return (
         <>
            <Nav />
            <SubNavAutre/>

            <div className="p-1 breadcrumbs xs-font mt-5 pt-4 pb-4">
               <a href="/bibliotheque" className="textPrimary fw-bold">Accueil</a> <span>/ Année missions</span>
            </div>
            <h4 className="page-title">Les années de missions</h4>
            <button onClick={newAnnee} className="btn btn-primary" style={{ float: "right", marginRight: "30px" }}>Créer une année de mission</button>
            <div className="container-fluid mt-4 mb-5">
               <div className="card p-3">
                  <table className={`table table-striped ${loading ? 'loading' : ''}`}>
                     <thead>
                        <tr>
                           <th>#</th>
                           <th>Année de mission</th>
                           <th className="text-center"></th>
                        </tr>
                     </thead>
                     <tbody>
                        {annees.map((annee, index) =>
                           <tr key={annee.id}>
                              <td>{index + 1}</td>
                              <td>{annee.libelle}</td>
                              <td>
                                 <button type="button" className="btn btn-sm btn-success" style={{ marginRight: "20px" }} onClick={() => updateAnnee(annee)} title="Modifier"><Pencil /></button>
                                 <button type="button" className="btn btn-sm btn-danger" onClick={() => removeAnnee(annee.id)} title="Supprimer"><Trash /></button>
                              </td>
                           </tr>
                        )}

                     </tbody>
                  </table>
               </div>

            </div>
            <Modal size="" show={showModal} title="Enregistrer une année de mission" body={<Form annee={annee} reset={{ libelle: "" }} close={onModalClose} />} onClose={onModalClose} />
         </>
      );
   }

   return <Layout body={<Body />} />
}